// extracted by mini-css-extract-plugin
module.exports = {"root":"DotLottie_root__oaI6A","lottie":"DotLottie_lottie__x27JB"};